// src/pages/docs/game/blackjack.jsx
import { Typography, Box, Link, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const BlackJackCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 800 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            /블랙잭, ?블랙잭
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}
          <br /><br />전적이의 블랙잭은 3개의 카드덱으로 사용하며
          <br />이용자가 7개의 카드를 버스트 없이 받으면 7 카드 찰리에 따라 이용자가 승리합니다.
          </Typography>
          <Typography variant="h6">
            {"사용법: /블랙잭 <코인, 하프, 올인>,"}<br />{"?블랙잭 <코인, 하프, 올인>"}<br />{"<>는 필수 사항입니다."}
          </Typography>
          <Typography variant="h6">
            {"동일 명령어: ?블랙잭, ?ㅂㄹㅈ, ?qfw"}
          </Typography>
          <Typography variant="body1" sx={{ mt: 3}}>
          {"예시: /블랙잭 5000, /ㅂㄹㅈ ㅎㅍ, ?qfw ㅇㅇ"}<br />승리 시 배팅 금액의 2배를 획득합니다.<br />비길 시 배팅 금액 모두를 돌려받습니다.
          </Typography>
          <Typography variant="h6"sx={{ mt: 3}}>
          {"블랙잭 명령어 확률"}
          </Typography>
          <Typography variant="body1">
          이길 확률: 약 43%<br />비길 확률: 약 9%
          </Typography>
          <Typography variant="body1" sx={{}}>
            <Link
                href="https://i.imgur.com/B3e4UeJ.png"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                블랙잭에서 잭팟(전적이, 플레이어 모두 블랙잭 50배)이 나올 확률: 약 0.209%
            </Link>
            </Typography>
            <Typography variant="body1" sx={{}}>
            <Link
                href="https://i.imgur.com/j5q5V4C.png"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                블랙잭에서 플레이어가 7 카드찰리(100배)로 이길 확률: 약 0.18%
            </Link>
            </Typography>
          
        </Box>

        {/* 오른쪽 이미지 + 버튼 묶음 */}
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: {xs:'center', md:'flex-start'},
          gap: 2,
          textAlign: { xs: 'center', md: 'left' },
          width: {xs:'100%',md:'auto'},
          maxWidth: {xs:'100%',md:'auto'},
        }}>
          {/* 이미지 */}
          <Box
            component="img"
            src="/commands/blackjack.webp"
            alt="설명 이미지"
            sx={{
              width: '100%',
              maxWidth: 400,
              borderRadius: 2,
              flexShrink: 0,
              mx: 'auto',
            }}
          />

          {/* 버튼들 */}
          {/* 바깥쪽 박스: 가운데 정렬용 (block + auto) */}
          <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'center' }, gap: 5, width: '100%', mt: 1 }}>
            {prev && (
              <Button href={prev.path} variant="outlined" sx={{ mr:{xs:0},height: 36, width: 118 }}>
                ← {prev.name}
              </Button>
            )}
            {next && (
              <Button href={next.path} variant="outlined" sx={{ height: 36, width: 118 }}>
                {next.name} →
              </Button>
            )}
          </Box>
        </Box>

      </Box>
    </DocsLayout>
  );
};

export default BlackJackCommand;
